import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import InvoiceBreakdown from '../Table/InvoiceBreakdown';
import FormHelperText from '@mui/material/FormHelperText';
import { logger } from "../../utils";


export default function InvoiceDialog({ handleDialogCallback, invoices }) {
	const [refresh, setRefresh] = React.useState(true);
	const [open, setOpen] = React.useState(false);
	const [LockedAlert, setAlert] = React.useState(false);   
	const [poChoices, setPoChoices] = React.useState([]);
	const [alertText, setAlertText] = React.useState([]);
	
	const generateDate = (date) => {
		var startDate = new Date();
		if (date === "end") {
			const enddate = new Date(startDate.getFullYear(), (startDate.getMonth()), 0).getDate();
			startDate = new Date(startDate.setMonth(startDate.getMonth() - 1));
			startDate = new Date(startDate.setDate(enddate));
		} else {
			startDate = new Date(startDate.setDate(1));
			startDate = new Date(startDate.setMonth(startDate.getMonth() - 1));
		}
		startDate = moment.utc(startDate).format("YYYY-MM-DD");
		return startDate;
	}

	const initialValues = {
		POID: '',
		invoice: 'Pending',
		start: generateDate("start") ,
		end: generateDate("end"),
		InvoiceDate: '',
		amount: ''
	};

	const validFormSchema = Yup.object({
		POID: Yup
			.string('Enter a PO to attach this invoice to ')
			.required('Linked PO is required'),
		invoice: Yup
			.string('Enter a name for the invoice')
			.required('Name is required'),
		start: Yup
			.date('Enter a start date "MM/DD/YYYY"')
			.required('Start date is required "MM/DD/YYYY"'),
		end: Yup
			.date('Enter a end date "MM/DD/YYYY"')
			.required('End date is required "MM/DD/YYYY"'),
		InvoiceDate: Yup
			.date('Enter a end date "MM/DD/YYYY"'),
		/*amount: Yup.number().test(
			'is-Currency',
			'invalid Currency',
			value => (value.toFixed(2) + "").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
		)*/
	})


	const onTrigger = React.useCallback((values) => {
		var tempAlert = [];
		var poStartDate = moment.utc(poChoices.filter(x => x.value == values.POID)[0].StartDate)
		var poEndDate = moment.utc(poChoices.filter(x => x.value == values.POID)[0].EndDate)
		const msg = {
			POID: values.POID,
			InvoiceNumber: values.invoice,
			StartDate: moment.utc(values.start),
			EndDate: moment.utc(values.end),
			InvoiceDate: moment.utc(values.InvoiceDate),
			Amount: parseFloat(values.amount).toFixed(2)
		};

		if ((!moment.utc(values.start).isSame(poStartDate) && !moment.utc(values.start).isBetween(poStartDate, poEndDate))
			|| (!moment.utc(values.end).isSame(poEndDate) && !moment.utc(values.end).isBetween(poStartDate, poEndDate))
		) {
			tempAlert.push(`outside PO dates (PO:${poChoices.filter(x => x.value == values.POID)[0].label} Start:${moment.utc(poStartDate).format("YYYY-MM-DD")} End:${moment.utc(poEndDate).format("YYYY-MM-DD")})`);
			setAlertText(tempAlert);
			setAlert(true);
			return;
		}

		if ((moment.utc(values.start) > moment.utc(values.end))) {
			tempAlert.push("EndDate cannot be earlier than StartDate, Please enter different time period");
			setAlertText(tempAlert);
			setAlert(true);
			return;
		} 
		
		for (var i = 0; i < invoices.length; i++) {
			var eachInvoice = invoices[i];
			if (eachInvoice.POID === values.POID && (moment(values.start).isBetween(eachInvoice.StartDate, eachInvoice.EndDate)
				|| moment(values.end).isBetween(eachInvoice.StartDate, eachInvoice.EndDate)
				|| moment(eachInvoice.StartDate).isBetween(values.start, values.end)
				|| moment(eachInvoice.EndDate).isBetween(values.start, values.end)
				|| moment(eachInvoice.StartDate).isSame(values.start)
				|| moment(eachInvoice.EndDate).isSame(values.end)
				|| moment(eachInvoice.StartDate).isSame(values.end)
				|| moment(eachInvoice.EndDate).isSame(values.start)
			)) {
				tempAlert.push(
					`Invoice (PO: ${poChoices.filter(x => x.value == values.POID)[0].label}) is already available with overlapping dates.
   Existing Invoice Period: ${moment(eachInvoice.StartDate).format("YYYY-MM-DD")} to ${moment(eachInvoice.EndDate).format("YYYY-MM-DD")}.
   Requested Period: ${moment(values.start).format("YYYY-MM-DD")} to ${moment(values.end).format("YYYY-MM-DD")}.
   Please check the request.`);
				setAlertText(tempAlert);
				setAlert(true);
				return;
			}
		}
			
		handleDialogCallback(msg);
		handleClose();
		
})

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleAlertClose = () => {
        setAlert(false);
    };

	const setChoices = (json) => {
		let choices = [];
		json.forEach(choice => choices.push({
			label: choice.CommonName + " (" + moment.utc(choice.StartDate).format("YYYY-MM-DD") + " - " + moment.utc(choice.EndDate).format("YYYY-MM-DD") + ")",
			value: choice.ID,
			StartDate: choice.StartDate,
			EndDate: choice.EndDate
		}))
		logger("set Po Choices to", choices)
		setPoChoices(choices)
	}

	React.useEffect(() => {

		if (refresh) {

			fetch('api/PO/dropdown', {
				method: 'Get',
			})
				.then(res => res.json())
				.then(json => setChoices(json));

			setRefresh(false);
		}
	})

	return (
		<div>
			<Button variant="contained" onClick={handleClickOpen}>
				Add Invoice
			</Button>
			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
				<DialogContent>
					<Formik
						initialValues={initialValues}
						validationSchema={validFormSchema}
						onSubmit={(values, { resetForm }) => {
							onTrigger(values);
							resetForm();
						}}
					>
						{props => (
							<Form>
								<AppBar sx={{ position: 'relative' }}>
									<Toolbar>
										<IconButton
											edge="start"
											color="inherit"
											onClick={handleClose}
											aria-label="close"
										>
											<CloseIcon />
										</IconButton>
										<Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
											Invoice
										</Typography>
										<Button autoFocus color="inherit" onClick={props.handleSubmit}>
											save
										</Button>
									</Toolbar>
								</AppBar>
								<DialogTitle>
									Invoice Info:
									<InvoiceBreakdown data={{
									PO: props.values.POID == '' ? '' :  poChoices.filter(choice => choice.value == props.values.POID)[0].label,
									POID: props.values.POID,
									InvoiceNumber: props.values.invoice,
									StartDate: moment.utc(props.values.start).format("YYYY-MM-DD"),
									EndDate: moment.utc(props.values.end).format("YYYY-MM-DD"),
									Amount: parseFloat(props.values.amount).toFixed(2),
									IsVoid: props.values.IsVoid
								}} /></DialogTitle>
								<div>
									<FormControl  sx={{ m: 1, width: 220 }}>
										<InputLabel htmlFor="outlined-Name">PO Name</InputLabel>
										<CustomSelect
											name="POID"
											id="outlined-costCenter"
											options={poChoices}
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.POID}
											error={props.touched.POID && Boolean(props.errors.POID)}
											helperText={props.touched.POID && props.errors.POID}
											label="POID"
										/>
										 {props.touched.POID && Boolean(props.errors.POID) &&
													<FormHelperText error={true}>{props.errors.POID}</FormHelperText>}
									</FormControl>

									<FormControl sx={{ m: 1, width: 220 }}>
										<TextField
											name='invoice'
											id="outlined-Location"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.invoice}
											error={props.touched.invoice && Boolean(props.errors.invoice)}
											helperText={props.touched.invoice && props.errors.invoice}
											disabled
											label="Invoice Number"
										/>
									</FormControl>
								</div>
								<div>
									<FormControl sx={{ m: 1, width: 220 }}>
										<TextField
											name='start'
											id="outlined-StartDate"
											type="date"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.start}
											error={props.touched.start && Boolean(props.errors.start)}
											helperText={props.touched.start && props.errors.start}
											label="Start Date"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</FormControl>

									<FormControl sx={{ m: 1, width: 220 }}>
										<TextField
											name='end'
											id="outlined-EndDate"
											type="date"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.end}
											error={props.touched.end && Boolean(props.errors.end)}
											helperText={props.touched.end && props.errors.end}
											label="End Date"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</FormControl>
								</div>
								<div>
									<FormControl sx={{ m: 1, width: 220 }}>
										<TextField
											name='amount'
											id="outlined-Amount"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.amount}
											error={props.touched.amount && Boolean(props.errors.amount)}
											helperText={props.touched.amount && props.errors.amount}
											label="Amount"
											required={false}
										/>
									</FormControl>
								</div>
								<div>
									<FormControl sx={{ m: 1, width: 220 }}>
										<TextField
											name='InvoiceDate'
											id="outlined-InvoiceDate"
											type="date"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.InvoiceDate}
											error={props.touched.InvoiceDate && Boolean(props.errors.InvoiceDate)}
											helperText={props.touched.InvoiceDate && props.errors.InvoiceDate}
											disabled
											label="Invoice Date"
											InputLabelProps={{
												shrink: true,
											}}
										/>
									</FormControl>
								</div>
							</Form>
						)}
					</Formik>
				</DialogContent>
				 <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Invoice Creation Issue"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText.map((a, index) => {
								return(<p key={index}>{a}</p>)
								})}
			            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setAlert(false);
                            setAlertText([]);
                        }} autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>                             
            </Dialog>
		</div>
	);
}
